import { render, staticRenderFns } from "./FormDerived.vue?vue&type=template&id=40fd5ae6&scoped=true&"
import script from "./FormDerived.vue?vue&type=script&lang=js&"
export * from "./FormDerived.vue?vue&type=script&lang=js&"
import style0 from "./FormDerived.vue?vue&type=style&index=0&id=40fd5ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fd5ae6",
  null
  
)

export default component.exports